import React from 'react';
import '../App.css';

const WrongUrl = ({ isWrongUrlError = true }) => {
    const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname)
        ? window.location.hostname.toLowerCase()
        : '';

    const searchParams = (typeof window !== 'undefined' && window.location && window.location.search)
        ? new URLSearchParams(window.location.search)
        : new URLSearchParams();
    const isGTC = searchParams.get('gtc') === 'true' || hostname.includes('globaltravelcollection.com');

    // Default (Travel Leaders)
    let brandLogoSrc = 'https://agents.travelleaders.com/Reviews/images/LogoTL_59.png';
    let brandLogoAlt = 'Travel Leaders Logo';
    let brandLogoLink = 'https://www.travelleaders.com';
    let brandContactLink = 'https://www.travelleaders.com/contact_us';
    let brandHeaderColor = 'white';
    let headingText = 'Oops! Something went wrong';
    let subText = (
        <>
            If the error persists,{' '}
            <a
                href={brandContactLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-tlBlue"
            >
                please contact us
            </a>
            .
        </>
    );

    // Dream Vacations
    if (hostname.includes('agents.dreamvacationsagentdirectory.com')) {
        brandLogoSrc = 'https://qa.agents.dreamvacationsagentdirectory.com/revImg/DV_Logo_CMYK.png';
        brandLogoAlt = 'Dream Vacations Logo';
        brandLogoLink = 'https://www.travelagents.dreamvacations.com/home';
        brandContactLink = 'https://www.dreamvacations.com/vacation/contact/get-in-touch';
        brandHeaderColor = 'white';
        headingText = 'Oops! Something went wrong.';

        subText = (
            <>
                If the error persists,{' '}
                <a
                    href={brandContactLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-tlBlue"
                >
                    please contact us
                </a>
                .
            </>
        );
    }

    // Cruise One
    else if (hostname.includes('agents.cruiseoneagentdirectory.com')) {
        brandLogoSrc = 'https://qa.agents.cruiseoneagentdirectory.com/revImg/CONE_Logo_CMYK.png';
        brandLogoAlt = 'Cruise One Logo';
        brandLogoLink = 'https://www.travelagents.cruiseone.com/home';
        brandContactLink = 'https://www.cruiseone.com/vacation/contact/get-in-touch';
        brandHeaderColor = 'white';
        headingText = 'Oops! Something went wrong.';

        subText = (
            <>
                If the error persists,{' '}
                <a
                    href={brandContactLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-tlBlue"
                >
                    please contact us
                </a>
                .
            </>
        );
    }

    // GTC override
    else if (isGTC) {
        brandLogoSrc = 'https://www.globaltravelcollection.com/images/logo-GTC-black.svg';
        brandLogoAlt = 'Global Travel Collection Logo';
        brandLogoLink = 'https://www.globaltravelcollection.com';
        brandContactLink = 'https://www.globaltravelcollection.com/contact-us';
        subText = (
            <>
                If the error persists,{' '}
                <a
                    href={brandContactLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-tlBlue"
                >
                    please contact us
                </a>
                .
            </>
        );
    }

    return (
        <div className="WrongUrl">
            <header
                className="shadow-md p-10 text-left relative"
                style={{ backgroundColor: brandHeaderColor }}
            >
                <a href={brandLogoLink} rel="noopener noreferrer" target="_blank">
                    <img
                        src={brandLogoSrc}
                        alt={brandLogoAlt}
                        className="max-h-16 inline-block"
                    />
                </a>
            </header>

            <div className="bg-white shadow-md p-20 mt-24 mb-10 w-11/12 max-w-2xl mx-auto text-center relative">
                <div className="relative">
                    <h1 className="text-3xl mb-2 pb-4 text-tlBlue">{headingText}</h1>
                    <h2 className="text-lg mb-2">{subText}</h2>
                </div>
            </div>
        </div>
    );
};

export default WrongUrl;
